import { CategoryKey } from 'config/categories';
import { EntryMode } from 'config/entry-mode';
import { StepId } from 'config/steps';
import { SelectableProduct } from 'types/selectable-product';
import { sessionStorageUtils } from 'utils/session-storage';
import { create } from 'zustand';

export type AppState = {
  currentStep: StepId | undefined;
  entryMode: EntryMode;
  metaSiteId: string | undefined;
  storeName: string | undefined;
  selectedCategory: CategoryKey;
  selectedProducts: SelectableProduct[];
  localFile: File | undefined;
  mediaUrl: string | undefined;
  siteUrl: string | undefined;
  wasStoresInstalledAtEntry: boolean | undefined;
};

type Store = AppState & {
  setCurrentStep: (currentStep: AppState['currentStep']) => void;
  setMetaSiteId: (metaSiteId: AppState['metaSiteId']) => void;
  setStoreName: (storeName: AppState['storeName']) => void;
  setSelectedCategory: (selectedCategory: AppState['selectedCategory']) => void;
  setSelectedProducts: (selectedProducts: AppState['selectedProducts']) => void;
  setLocalFile: (localFile: AppState['localFile']) => void;
  setMediaUrl: (mediaUrl: AppState['mediaUrl']) => void;
  setSiteUrl: (siteUrl: AppState['siteUrl']) => void;
};

const initialState: AppState = sessionStorageUtils.getInitialAppState();

export const useAppStore = create<Store>()((set) => ({
  ...initialState,
  setCurrentStep: (currentStep) => set({ currentStep }),
  setMetaSiteId: (metaSiteId) => set({ metaSiteId }),
  setStoreName: (storeName) => set({ storeName }),
  setSelectedCategory: (selectedCategory) => set({ selectedCategory }),
  setSelectedProducts: (selectedProducts) => set({ selectedProducts }),
  setLocalFile: (localFile) => set({ localFile }),
  setMediaUrl: (mediaUrl) => set({ mediaUrl }),
  setSiteUrl: (siteUrl) => set({ siteUrl }),
}));

useAppStore.subscribe((state) => {
  sessionStorageUtils.setAppState(state);
});
